import getDateValue from '../get-date-value';
import getMonthName from '../get-month-name';
import isToday from '../is-today';
import isTomorrow from '../is-tomorrow';
import isYesterday from '../is-yesterday';

const isRelativeDay = (date: Date): boolean =>
  isToday(date) || isYesterday(date) || isTomorrow(date);

export const getCalendarDateText = (date: Date): string => {
  const dayLabel = getDateValue(date);
  const dayNumber = date.getDate();
  const monthName = getMonthName(date);

  // Relative days (I dag, I går, I morgen) use comma separator
  // Weekday names (Mandag, Tirsdag) use space separator
  const separator = isRelativeDay(date) ? ',' : '';

  return `${dayLabel}${separator} ${dayNumber}. ${monthName}`;
};

export default getCalendarDateText;
